import { create } from 'zustand';

interface CommentLayoutState {
  open: boolean;
  setOpen: (open: boolean) => void;
  openDrawerWidth: number;
  closedDrawerWidth: number;
  getDrawerWidth: () => number;
}

export const useCommentLayout = create<CommentLayoutState>((set, get) => ({
  open: false,
  setOpen: open => set({ open }),
  openDrawerWidth: 400,
  closedDrawerWidth: 0,
  getDrawerWidth: () => (get().open ? get().openDrawerWidth : get().closedDrawerWidth),
}));
